/**
 * nb-cmax-compare-ways.js
 * Scoped behaviour for the PDP compare section: two-state toggle (Against everything
 * else, default / Against the Clean) and the in-place expand/collapse of the four extra
 * rows inside the "Against the Clean" panel only. Plain JS, no library, scoped to the
 * section root so two copies on one page never collide. Supports #compare-all: opens
 * "Against the Clean" with every row expanded and scrolls the section into view.
 */
(function () {
  'use strict';

  function initOne(root) {
    if (root.hasAttribute('data-nb-compare-init')) return;
    root.setAttribute('data-nb-compare-init', '');

    var tabs = root.querySelectorAll('[data-nb-compare-tab]');
    var panels = root.querySelectorAll('[data-nb-compare-panel]');
    var heading = root.querySelector('[data-nb-compare-heading]');
    var expandWraps = root.querySelectorAll('[data-nb-compare-expand-wrap]');
    var expandBtns = root.querySelectorAll('[data-nb-compare-expand]');
    var expandLabels = root.querySelectorAll('[data-nb-compare-expand-label]');
    var expandIcons = root.querySelectorAll('[data-nb-compare-expand-icon]');
    var extraRows = root.querySelectorAll('[data-nb-compare-row-extra]');
    var expandLabelText = (expandLabels[0] && expandLabels[0].textContent.trim()) || 'See every difference';
    var collapseLabelText = root.getAttribute('data-collapse-label') || 'Show fewer';

    function setTab(key) {
      tabs.forEach(function (btn) {
        var active = btn.getAttribute('data-nb-compare-tab') === key;
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-nb-compare-panel') !== key;
      });
      if (heading) {
        heading.textContent = key === 'against'
          ? heading.getAttribute('data-heading-against')
          : heading.getAttribute('data-heading-everything');
      }
      expandWraps.forEach(function (wrap) { wrap.hidden = key !== 'against'; });
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTab(btn.getAttribute('data-nb-compare-tab'));
      });
    });

    function setExpanded(open) {
      extraRows.forEach(function (row) {
        row.hidden = !open;
      });
      expandBtns.forEach(function (btn) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      expandLabels.forEach(function (label) { label.textContent = open ? collapseLabelText : expandLabelText; });
      expandIcons.forEach(function (icon) { icon.textContent = open ? '−' : '+'; });
    }

    expandBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setExpanded(btn.getAttribute('aria-expanded') !== 'true');
      });
    });

    function openFromHash() {
      if (window.location.hash === '#compare-all') {
        setTab('against');
        setExpanded(true);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    openFromHash();
    window.addEventListener('hashchange', openFromHash);
  }

  function init() {
    document.querySelectorAll('[data-nb-compare-ways]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
